import * as APITypes from "~/API";
import { getAmenityList } from "~/services/server";
import { buildPropertyMap } from "../helpers";
import type { EntityListData, EntityListOptions } from "~/types";

export const formatAmenityOptions = (
  amenityList: APITypes.Amenity[],
  propertyMap: Record<string, APITypes.Property>
): EntityListOptions[] => {
  return amenityList.map((amenity) => {
    const property = propertyMap[amenity.propertyID];
    return {
      value: amenity.id,
      text: `Amenity: ${amenity.name} - Property: ${
        property?.name || "Unknown"
      }`,
    };
  });
};

export const getAmenityEntityList = async (
  ownerID: string,
  ownerType: APITypes.OwnerType
): Promise<EntityListData> => {
  const amenityList = await getAmenityList({ ownerID, ownerType });
  const propertyMap = await buildPropertyMap(ownerID, ownerType);

  return {
    propertyList: [],
    buildingList: [],
    unitList: [],
    serviceRequestList: [],
    amenityList: amenityList.data,
    propertyMap,
    buildingMap: {},
    unitMap: {},
  };
};
